import type { SvgIconComponent } from '@mui/icons-material';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import MarkEmailReadOutlinedIcon from '@mui/icons-material/MarkEmailReadOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined';

import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import CompareArrowsOutlinedIcon from '@mui/icons-material/CompareArrowsOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';

const KNOWLEDGE_ARTICLE_ICONS: Record<string, SvgIconComponent> = {
  dashboard: DashboardOutlinedIcon,
  'dashboard-overview': DashboardOutlinedIcon,
  'dashboard-monthly-tab': TimelineOutlinedIcon,
  'dashboard-organization-overview': InsightsOutlinedIcon,
  'customize-dashboard': TuneOutlinedIcon,
  'kpi-limits': FlagOutlinedIcon,
  'download-report': DownloadOutlinedIcon,
  'dashboard-maps': LocationOnOutlinedIcon,
  'branch-analysis': StorefrontOutlinedIcon,
  'branch-analysis-overview': StorefrontOutlinedIcon,
  'compare-branches': CompareArrowsOutlinedIcon,
  organizations: BusinessOutlinedIcon,
  'organizations-overview': BusinessOutlinedIcon,
  'manage-organization': BusinessOutlinedIcon,
  'organization-logo': ImageOutlinedIcon,
  approvals: FactCheckOutlinedIcon,
  notifications: NotificationsOutlinedIcon,
  'notification-bell': NotificationsOutlinedIcon,
  'mark-notifications-read': MarkEmailReadOutlinedIcon,
  'user-management': PeopleOutlinedIcon,
  'add-user': PersonAddOutlinedIcon,
  'users-overview': PeopleOutlinedIcon,
  'permissions-handbook': SecurityOutlinedIcon,
  'account-settings': ManageAccountsOutlinedIcon,
  'change-language': LanguageOutlinedIcon,
  'appearance-theme': DarkModeOutlinedIcon,
};

export const getKnowledgeArticleIcon = (articleId: string): SvgIconComponent => {
  if (articleId.includes('truck')) return LocalShippingOutlinedIcon;
  if (articleId.includes('container')) return LocationOnOutlinedIcon;
  return KNOWLEDGE_ARTICLE_ICONS[articleId] ?? MenuBookOutlinedIcon;
};
